import { render } from "./CDropdown.vue?vue&type=template&id=edd7b8a8&scoped=true"
import script from "./CDropdown.vue?vue&type=script&lang=js"
export * from "./CDropdown.vue?vue&type=script&lang=js"

import "./CDropdown.vue?vue&type=style&index=0&id=edd7b8a8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edd7b8a8"]])

export default __exports__